export default __webpack_public_path__ + "static/media/vision-plan.f9832037.svg";